import React from 'react';
import { Route, Switch } from 'react-router';
import EndSubscription from './EndSubscription';
import Upgrade from './Upgrade';
import Payment from './Payment';
import Invoice from './Invoice';
import Employee from './Employee';
import Installation from './Installation';

class CompanySettings extends React.Component {

    render(){
        return (
            <Switch>
                <Route path='/companySettings/upgrade' component={Upgrade}/>
                <Route path='/companySettings/payment' component={Payment}/>
                <Route path='/companySettings/endSubscription' component={EndSubscription}/>
                <Route path='/companySettings/invoice' component={Invoice}/>
                <Route path='/companySettings/employee' component={Employee}/>
                <Route path='/companySettings/installation' component={Installation}/>
            </Switch>
        )
    }
}


export default CompanySettings;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/index.js